/**
 * Next episode button component.
 */
import Container from '@components/atoms/container/nextEpisodeButtonContainer';
import Fill from '@components/atoms/container/nextEpisodeFillContainer';
import Icon from '@components/atoms/icons/playOutline';
import ListContext from '@shared/components/utils/context/listContext';
import Content from '@components/atoms/container/nextEpisodeContentContainer';
import Props from '@shared/types/props/pressable';
import { selectMagicRemoteEnabled } from '@shared/store/slices/magicRemote.slice';
import { useAppSelector } from '@shared/store/hooks';
import { useContext, useState, useCallback, useEffect } from 'react';

export default function NextEpisodeButton({
  action,
  releaseAction,
  fill,
  index,
  text,
}: Props) {
  const enabled = useAppSelector(selectMagicRemoteEnabled);
  const { listIndex, listFocused } = useContext(ListContext);
  const [hasFocus, setHasFocus] = useState(false);
  const focused = !enabled && hasFocus;

  // Event handlers

  const onPointerEnter = useCallback(() => {
    setHasFocus(true);
  }, []);

  const onPointerLeave = useCallback(() => {
    setHasFocus(listIndex === index);
  }, [listIndex]);

  // Effect hooks

  useEffect(() => {
    setHasFocus(listFocused && listIndex === index);
  }, [listIndex, listFocused]);

  return (
    <Container
      focused={focused}
      onClick={action || releaseAction}
      onPointerEnter={onPointerEnter}
      onPointerLeave={onPointerLeave}
    >
      <Content focused={focused}>
        {fill !== undefined ? <Icon focused={focused} /> : null}
        {text}
      </Content>
      {fill !== undefined ? <Fill fill={fill} focused={focused} /> : null}
    </Container>
  );
}
